// FAQAccordion.js
import React, { useState } from 'react';

const FAQAccordion = ({ accordionData }) => {
    const [openIndex, setOpenIndex] = useState(null);

    const handleToggleCollapse = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const accordion_data = [
        {
            title: "How do I use the voice recorder?",
            content: "It’s easy! Just press the red record button. A countdown will appear, then start speaking. (You may need to allow microphone permissions.)"
        },
        {
            title: "Will it work with my microphone?",
            content: "Yes! Our sound recorder app supports all microphones across different devices and operating systems. If you face issues, please reach out to us. (Make sure to grant microphone permissions.)"
        },
        {
            title: "How good is the audio quality?",
            content: "Our audio voice recorder captures audio in high quality. The final results depend on your microphone and background noise."
        },
        {
            title: "How long can I record?",
            content: "The online audio recorder offers unlimited recording time for premium users."
        },
        {
            title: "Where are my recordings saved?",
            content: "Recordings are saved locally on your device. Premium users can also save recordings to cloud storage."
        },
        {
            title: " How do I share a recording?",
            content: "Open the recording, tap the share icon, and choose to share it (e.g., email, social media)."
        },
        {
            title: "Can I edit my recordings?",
            content: "Yes, you can edit your recordings with our built-in editor."
        },
        {
            title: "Can I get a transcript of my recording?",
            content: "Yes. The AI tools transcribe recordings of up to 30 minutes into a written transcript with a summary alongside it. You can edit the text, copy it to your clipboard, or download it as a .txt file."
        },
        {
            title: "Can I turn text into audio?",
            content: "Yes. Upload a text file of up to 5,000 characters to Text to Speech and we will read it out loud and save the result to your recordings."
        },
        {
            title: "Can I translate my text or transcript?",
            content: "Yes. Upload a text file to Translate, or translate a transcript and its summary straight from the transcript screen, into any of more than 45 languages. The translation can be copied or downloaded as a .txt file."
        },
        {
            title: "Can I pull the audio out of a video?",
            content: "Yes. Upload an MP4, MOV or WebM file to Extract Audio and the soundtrack is saved straight into My Recordings, ready to trim, convert or transcribe."
        },
        {
            title: "Can I clean up a noisy recording?",
            content: "Yes. The Speed Controller removes background noise, boosts quiet audio and changes playback speed from 0.5x to 2x, and you can save the cleaned-up version as a new recording."
        },
        {
            title: "How do I keep my recordings organised?",
            content: "Group recordings into folders, star the ones you use most as favourites, and attach a note to any recording so you remember what is in it."
        },
        {
            title: "Is there a limit to the number of recordings?",
            content: "No, you can make unlimited recordings with a premium plan."
        },
        {
            title: " Is Voice Recorder available on mobile?",
            content: "Yes. Voice Recorder is available on desktop, iOS, and Android devices."
        },


    ];

    return (
        <div id="regularAccordionRobots" className="accordion" >
            {accordion_data.map((item, index) => (
                <div
                    className="accordion-item accordion_item_border border_accordion_item_border"
                    key={index}
                    onClick={() => handleToggleCollapse(index)}
                    style={{ backgroundColor: "transparent" }}
                >
                    <h2
                        id={`regularHeading${index}`}
                        className="accordion-header"
                        style={{
                            background: openIndex === index ? "" : "",
                            padding: openIndex === index ? "22px 10px 10px 10px" : "22px 10px",
                            fontWeight: "600 !important"
                        }}
                    >
                        <h6
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginBottom: "0px",

                            }}
                            // aria-expanded={openIndex === index ? "true" : "false"}
                            aria-controls={`regularCollapse${index}`}
                        >
                            <span style={{ fontWeight: "500", fontSize: "16px" }}>

                                {item.title}
                            </span>
                            <img
                                src={
                                    openIndex === index
                                        ? "/img/dashboard/faq_arrowup.png"
                                        : "/img/dashboard/faq_arrowdown.png"
                                }
                                alt="Toggle Icon"
                                style={{
                                    marginRight: "20px",
                                    width: "20px",
                                    height: "20px",
                                    cursor: "pointer",
                                }}
                            />
                        </h6>

                    </h2>
                    <div
                        id={`regularCollapse${index}`}
                        className={`accordion-collapse collapse ${openIndex === index ? "show" : ""}`}
                        style={{ paddingRight: "25px", paddingBottom: "22px", paddingLeft: "10px" }}
                        aria-labelledby={`regularHeading${index}`}
                    >
                        <div className="accordion-body" style={{ color: "#475569", width: "95%", fontWeight: "400", fontSize: "14px" }}>
                            {item.content}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default FAQAccordion;
